<!-- eslint-disable vuejs-accessibility/anchor-has-content -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div class="modal-content" v-if="reasons">
    <div class="modal-header">
      <h4 class="modal-title"><b>تأكيد تسوية عقد</b></h4>
      <a class="modal-close" @click="onClose"><i class="fa fa-times fa-lg" aria-hidden="true"></i></a>
    </div>
    <ValidationObserver ref="form">
      <div class="modal-body">
        <ValidationProvider name="reason" rules="required" v-slot="{ errors }">
          <label class="pb-2">سبب تسوية العقد</label>
          <v-select :items="reasons" :value="selectedReasonId" item-text="reason" item-value="id" solo clearable
            @change="onReasonChanged" :error-messages="errors"></v-select>
        </ValidationProvider>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link px-5 font-weight-bold" data-dismiss="modal"
          @click="onClose">تراجع</button>
        <button type="button" class="btn btn-danger text-white px-5" @click="onSend">إرسال</button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';

import { EventBus, Events } from '@/event-bus';
import LookupService from '@/services/lookup.service';
import { ContractCloseReason } from '@/models/lookup.model';
import { ContractStatusEnum } from '@/enums/contract-status.enum';

@Component({
  diProvide: [
    LookupService,
  ],
})
export default class SettleContractComponent extends Vue {
  @Inject(LookupService) public lookupService!: LookupService;

  reasons: ContractCloseReason[] | null = null;
  selectedReasonId: number | null = null;

  async mounted(): Promise<void> {
    const response = await this.lookupService.getContractCloseReasons();

    if (response.result) {
      this.reasons = response.result.filter((r) => r.contractStatusId === ContractStatusEnum.Closed);
    }
  }

  onReasonChanged(option: number): void {
    this.selectedReasonId = option;
  }

  async onSend(): Promise<void> {
    const valid = await (this.$refs.form as any).validate();

    if (!valid) return;

    EventBus.$emit(Events.Contract.ConfirmSettleContractEvent, this.selectedReasonId);
    this.onClose();
  };

  onClose(): void {
    EventBus.$emit(Events.Dialog.CloseDialogEvent);
    this.selectedReasonId = 0;
    (this.$refs.form as any).reset();
  }
}
</script>

<style scoped>
.modal-body {
  padding: 1em 2em !important;
}

.modal-body p {
  font-size: 1.1rem;
  margin-bottom: 0;
}
</style>
@/enums/contract-status.enum